<pbc-sorter [config]="FeldKategoriesSorterConfig" [sorter]="feldKategories.sorter$ | async" (sorterChange)="feldKategories.sorter$.next($event)"></pbc-sorter>
